/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Accesibilidad: el tema usa aria-hidden="true" en varios componentes (carrusel de
 * productos con scroll, slides inactivos del slideshow, mini-carrito, menús, popovers,
 * modales) para ocultarlos de lectores de pantalla mientras no están visibles/activos.
 * Pero los enlaces/botones que quedan dentro siguen siendo alcanzables con la tecla Tab,
 * lo que confunde a usuarios de teclado y lectores de pantalla (detectado por axe:
 * "ARIA hidden element must not be focusable or contain focusable elements").
 *
 * Esta función mantiene el tabindex sincronizado con aria-hidden en todo el sitio: al
 * ocultar, saca del orden de tabulación; al mostrar, restaura el tabindex original.
 * No cambia nada visual ni de comportamiento, solo corrige el foco de teclado.
 */
(function () {
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';
  var PREV_ATTR = 'data-a11y-prev-tabindex';

  function disableFocus(el) {
    var targets = el.matches(FOCUSABLE) ? [el] : [];
    targets = targets.concat(Array.prototype.slice.call(el.querySelectorAll(FOCUSABLE)));
    targets.forEach(function (f) {
      if (!f.hasAttribute(PREV_ATTR)) {
        f.setAttribute(PREV_ATTR, f.hasAttribute('tabindex') ? f.getAttribute('tabindex') : '');
      }
      f.setAttribute('tabindex', '-1');
    });
  }

  function restoreFocus(el) {
    var targets = el.hasAttribute(PREV_ATTR) ? [el] : [];
    targets = targets.concat(Array.prototype.slice.call(el.querySelectorAll('[' + PREV_ATTR + ']')));
    targets.forEach(function (f) {
      var prev = f.getAttribute(PREV_ATTR);
      if (prev) {
        f.setAttribute('tabindex', prev);
      } else {
        f.removeAttribute('tabindex');
      }
      f.removeAttribute(PREV_ATTR);
    });
  }

  function sync(el) {
    if (el.getAttribute('aria-hidden') === 'true') {
      disableFocus(el);
    } else {
      restoreFocus(el);
    }
  }

  function init() {
    document.querySelectorAll('[aria-hidden="true"]').forEach(disableFocus);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
          sync(mutation.target);
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['aria-hidden'],
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * Accesibilidad: un contenedor con scroll real (overflow: auto/scroll y contenido que
 * de hecho desborda) tiene que poder alcanzarse con teclado. Si no tiene ya un
 * link/botón enfocable adentro, un usuario de teclado no tiene forma de llegar a él para
 * desplazarlo con las flechas (detectado por axe: "scrollable-region-focusable"). Pasa
 * sobre todo en mobile/tablet: tablas anchas en la descripción de producto, el carrusel
 * de categorías del menú, el listado de miniaturas, etc. Esta función revisa los
 * contenedores con scroll conocidos del tema y agrega tabindex="0" solo donde hace
 * falta (nunca lo saca si ya tiene uno propio).
 */
(function () {
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';
  var CANDIDATES =
    '.table-wrapper, .scroller__inner, .mini-cart__line-item-list, .collection-drawer__inner, ' +
    '.search-bar__menu-wrapper, .search-bar__results, .map__store-list, .nav-dropdown--restrict, ' +
    '.nav-bar .nav-dropdown .nav-dropdown, .mega-menu__inner, .nav-bar .mega-menu, .popover__inner, ' +
    '.product-gallery__thumbnail-list, .modal__dialog, .value-picker__choice-list';

  function isScrollable(el) {
    var cs = window.getComputedStyle(el);
    var scrollsX = (cs.overflowX === 'auto' || cs.overflowX === 'scroll') && el.scrollWidth > el.clientWidth;
    var scrollsY = (cs.overflowY === 'auto' || cs.overflowY === 'scroll') && el.scrollHeight > el.clientHeight;
    return scrollsX || scrollsY;
  }

  function check() {
    document.querySelectorAll(CANDIDATES).forEach(function (el) {
      if (el.hasAttribute('tabindex') || el.matches(FOCUSABLE)) {
        return;
      }
      if (el.querySelector(FOCUSABLE)) {
        return; // ya se puede llegar con Tab a algo adentro
      }
      if (isScrollable(el)) {
        el.setAttribute('tabindex', '0');
      } else {
        el.removeAttribute('tabindex');
      }
    });
  }

  var scheduled = false;
  function scheduleCheck() {
    if (scheduled) {
      return;
    }
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      check();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else {
    check();
  }

  window.addEventListener('resize', scheduleCheck);

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(scheduleCheck);
    var startObserving = function () {
      observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    };
    if (document.body) {
      startObserving();
    } else {
      document.addEventListener('DOMContentLoaded', startObserving);
    }
  }
})();

/**
 * Accesibilidad: varios modales del tema (quick view de producto, popup de newsletter,
 * modales de dirección en la cuenta) usan role="dialog" pero no tienen nombre accesible
 * (ni aria-label ni aria-labelledby), así que un lector de pantalla solo anuncia
 * "diálogo" sin decir de qué se trata (detectado por axe: "aria-dialog-name"). Esta
 * función busca el título/heading visible que ya está adentro de cada diálogo y lo
 * conecta con aria-labelledby. El quick view trae su contenido después por fetch, así
 * que también se revisa cuando se inserta contenido nuevo o cuando el modal se abre.
 */
(function () {
  var HEADING_SELECTOR = 'h1, h2, h3, h4, h5, h6, legend, [class*="title"], [class*="heading"]';
  var autoIdCounter = 0;

  function nameDialog(dialog) {
    if (!dialog.matches || !dialog.matches('[role="dialog"], [role="alertdialog"]')) {
      return;
    }
    if (dialog.hasAttribute('aria-label') || dialog.hasAttribute('aria-labelledby')) {
      return;
    }
    var heading = dialog.querySelector(HEADING_SELECTOR);
    if (!heading || !heading.textContent.trim()) {
      return;
    }
    if (!heading.id) {
      autoIdCounter += 1;
      heading.id = 'sh-a11y-dialog-title-' + autoIdCounter;
    }
    dialog.setAttribute('aria-labelledby', heading.id);
  }

  function scan(root) {
    var scope = root || document;
    scope.querySelectorAll('[role="dialog"], [role="alertdialog"]').forEach(nameDialog);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') {
          if (mutation.target.querySelectorAll) {
            scan(mutation.target);
          }
        } else if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) {
              return;
            }
            nameDialog(node);
            if (node.querySelectorAll) {
              scan(node);
            }
          });
        }
      });
    });

    var startObserving = function () {
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
    };
    if (document.body) {
      startObserving();
    } else {
      document.addEventListener('DOMContentLoaded', startObserving);
    }
  }
})();

/**
 * Mini preview de fotos en las tarjetas de producto: cuando un producto tiene más de una
 * foto, se van mostrando en loop con fundido suave SOLO mientras el mouse está encima de
 * la tarjeta (antes rotaba solo todo el tiempo, ahora es a demanda). El ciclo es rápido
 * para que se sienta ágil apenas se pasa el mouse. Al salir el mouse, vuelve a la foto
 * principal. También funciona con teclado (focus/blur) para no perder accesibilidad.
 */
(function () {
  var STEP_MS = 550;

  function setupGallery(wrapper) {
    var primary = wrapper.querySelector('.product-item__primary-image');
    var extras = Array.prototype.slice.call(wrapper.querySelectorAll('.product-item__gallery-image'));
    var dots = Array.prototype.slice.call(wrapper.querySelectorAll('.product-item__gallery-dot'));

    if (!primary || extras.length === 0) {
      return;
    }

    var frames = [primary].concat(extras);
    var index = 0;
    var timer = null;

    function show(next) {
      frames[index].classList.remove('is-active');
      if (index === 0) {
        frames[0].classList.add('is-gallery-hidden');
      }

      index = next;

      if (index === 0) {
        frames[0].classList.remove('is-gallery-hidden');
      } else {
        frames[index].classList.add('is-active');
      }

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function tick() {
      show((index + 1) % frames.length);
    }

    function start() {
      if (timer) {
        return;
      }
      timer = setInterval(tick, STEP_MS);
    }

    function stop() {
      clearInterval(timer);
      timer = null;
    }

    function reset() {
      if (index !== 0) {
        show(0);
      }
    }

    wrapper.addEventListener('mouseenter', start);
    wrapper.addEventListener('mouseleave', function () {
      stop();
      reset();
    });

    // Equivalente por teclado: al enfocar cualquier control dentro de la tarjeta (el link
    // del producto, por ejemplo) también se activa el ciclo; al salir del todo, se apaga.
    wrapper.addEventListener('focusin', start);
    wrapper.addEventListener('focusout', function (event) {
      if (!wrapper.contains(event.relatedTarget)) {
        stop();
        reset();
      }
    });
  }

  function init() {
    document.querySelectorAll('.product-item__image-wrapper--gallery').forEach(setupGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

/**
 * Coordinador simple para el loader normal y la bienvenida: mientras cualquiera de los dos
 * sigue tapando la página, `window.__shContentVisible` queda en false. Cuando el último que
 * corresponda mostrarse termina, se pone en true y se dispara 'sh:content-visible' en
 * document. Cualquier animación que dependa de que el usuario YA esté viendo la página real
 * (por ejemplo el count-up de la stats bar) debe esperar a esto en vez de arrancar apenas
 * el elemento entra en el viewport: si no, puede terminar de animar mientras todavía está
 * tapada por el loader/bienvenida, y el usuario nunca la ve moverse.
 */
(function () {
  var pending = 0;
  if (document.getElementById('site-preloader')) {
    pending++;
  }
  if (document.getElementById('site-welcome') && !window.__shSkipWelcome) {
    pending++;
  }

  window.__shContentVisible = pending === 0;

  window.__shMarkOverlayDone = function () {
    pending--;
    if (pending <= 0 && !window.__shContentVisible) {
      window.__shContentVisible = true;
      document.dispatchEvent(new CustomEvent('sh:content-visible'));
    }
  };
})();

/**
 * Loader normal: aparece SIEMPRE en cada carga de página, con el logo y un fundido
 * simple y rápido. No depende del día. Nunca se puede quedar "pegado": si algo tarda de
 * más, se oculta igual a los 2.5s como salvavidas.
 */
(function () {
  var preloader = document.getElementById('site-preloader');
  if (!preloader) {
    return;
  }

  var logoImg = document.getElementById('site-preloader-logo');
  if (logoImg) {
    if (window.theme && window.theme.logoUrl) {
      logoImg.src = window.theme.logoUrl;
    } else {
      logoImg.style.display = 'none';
    }
  }

  var hidden = false;

  function hide() {
    if (hidden) {
      return;
    }
    hidden = true;
    preloader.classList.add('is-hidden');
    if (window.__shMarkOverlayDone) {
      window.__shMarkOverlayDone();
    }
    window.setTimeout(function () {
      if (preloader.parentNode) {
        preloader.parentNode.removeChild(preloader);
      }
    }, 500);
  }

  if (document.readyState === 'complete') {
    window.setTimeout(hide, 150);
  } else {
    window.addEventListener('load', function () {
      window.setTimeout(hide, 150);
    });
  }

  window.setTimeout(hide, 2500);
})();

/**
 * Bienvenida: presentación aparte y más elaborada, SOLO para la primera visita del día
 * (window.__shSkipWelcome la salta al instante, ver el script sincrónico en theme.liquid).
 * Se queda un momento más para que se sienta como una bienvenida real y no un parpadeo, y
 * se despide con una cortina que sube y revela el sitio. Nunca se puede quedar "pegada".
 */
(function () {
  var welcome = document.getElementById('site-welcome');
  if (!welcome) {
    return;
  }

  function remove() {
    if (welcome.parentNode) {
      welcome.parentNode.removeChild(welcome);
    }
  }

  // Ya se mostró hoy: el script sincrónico de theme.liquid ya la ocultó con CSS
  // (display:none) antes del primer paint. Acá solo falta sacarla del DOM.
  if (window.__shSkipWelcome) {
    remove();
    return;
  }

  var logoImg = document.getElementById('site-welcome-logo');
  if (logoImg) {
    if (window.theme && window.theme.logoUrl) {
      logoImg.src = window.theme.logoUrl;
    } else {
      logoImg.style.display = 'none';
    }
  }

  var wordEl = document.getElementById('site-welcome-word');
  var underline = document.getElementById('site-welcome-underline');
  var words = (window.theme && window.theme.welcomeWords && window.theme.welcomeWords.length)
    ? window.theme.welcomeWords
    : ['WELCOME.'];

  var hidden = false;
  var wordsDone = false;
  var pageLoaded = document.readyState === 'complete';

  function hide() {
    if (hidden) {
      return;
    }
    hidden = true;
    welcome.classList.add('is-hidden');
    if (window.__shMarkOverlayDone) {
      window.__shMarkOverlayDone();
    }
    window.setTimeout(remove, 850);
  }

  function maybeHide() {
    if (wordsDone && pageLoaded) {
      hide();
    }
  }

  window.addEventListener('load', function () {
    pageLoaded = true;
    maybeHide();
  });

  // Recorre las frases de marca una por una (fundido + deslizamiento) y termina en el
  // mensaje de bienvenida final, que se queda quieto mientras crece la rayita debajo.
  function runWordCycle() {
    var STEP_MS = 480;
    var FADE_MS = 260;
    var HOLD_LAST_MS = 500;
    var i = 0;

    function show(word) {
      wordEl.textContent = word;
      wordEl.classList.remove('is-visible');
      void wordEl.offsetWidth; // fuerza reflow para reiniciar la transición
      wordEl.classList.add('is-visible');
    }

    function step() {
      var isLast = i === words.length - 1;
      show(words[i]);

      if (isLast) {
        window.setTimeout(function () {
          if (underline) {
            underline.classList.add('is-grown');
          }
          window.setTimeout(function () {
            wordsDone = true;
            maybeHide();
          }, 450);
        }, FADE_MS + HOLD_LAST_MS);
        return;
      }

      window.setTimeout(function () {
        wordEl.classList.remove('is-visible');
        window.setTimeout(function () {
          i++;
          step();
        }, FADE_MS);
      }, STEP_MS);
    }

    if (wordEl) {
      step();
    } else {
      wordsDone = true;
    }
  }

  runWordCycle();

  // Salvavidas: nunca se puede quedar pegada, pase lo que pase con la carga.
  window.setTimeout(hide, 5000);
})();

/**
 * Aparición suave (fade + slide) de las secciones de la página a medida que se hace
 * scroll. Mejora progresiva: la clase que las oculta la agregamos acá mismo justo antes
 * de empezar a observarlas, así que sin JS (o si algo falla) nunca queda contenido
 * escondido. Lo que ya está a la vista al cargar se muestra directo, sin animar.
 */
(function () {
  if (!('IntersectionObserver' in window)) {
    return;
  }

  /* A pedido explícito: esta animación corre siempre, incluso con prefers-reduced-motion
   * activado en el sistema. Es solo un fundido + deslizamiento corto (opacity + translateY
   * de unos 20px), no dispara mareo/vestibular como sí puede hacerlo un parallax o zoom
   * agresivo, y es la animación que más se nota recorriendo el sitio (sin ella, muchos
   * navegadores/sistemas con "reducir movimiento" activado ven el sitio como "sin
   * animaciones" aunque el resto del tema sí las tenga). */

  var observedSections = typeof WeakSet === 'function' ? new WeakSet() : null;

  function isInViewport(el) {
    var rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  function observe(el) {
    if (observedSections) {
      if (observedSections.has(el)) {
        return;
      }
      observedSections.add(el);
    }

    el.classList.add('reveal-on-scroll');

    if (isInViewport(el)) {
      el.classList.add('is-revealed');
      return;
    }

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    observer.observe(el);
  }

  function init() {
    var main = document.getElementById('main');
    if (!main) {
      return;
    }

    Array.prototype.slice.call(main.children).forEach(function (el) {
      if (el.classList && el.classList.contains('shopify-section')) {
        observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

/**
 * Filtros de la página "Brands" (Todas / Premium / A-Z): "Premium" se calcula con el
 * precio real más alto de cada marca (viene en data-max-price desde el Liquid, no es un
 * número inventado) — se toma como "premium" el 25% de marcas con el precio más alto.
 * Las letras del A-Z sin ninguna marca se deshabilitan solas. Filtra con un fundido
 * suave en vez de aparecer/desaparecer de golpe.
 */
(function () {
  var container = document.getElementById('brand-filters');
  var grid = document.getElementById('brand-grid');
  var emptyMessage = document.getElementById('brand-filters-empty');

  if (!container || !grid) {
    return;
  }

  var cards = Array.prototype.slice.call(grid.querySelectorAll('.quick-links__link'));

  var prices = cards
    .map(function (card) {
      return parseFloat(card.getAttribute('data-max-price')) || 0;
    })
    .filter(function (price) {
      return price > 0;
    })
    .sort(function (a, b) {
      return a - b;
    });

  var premiumThreshold = prices.length ? prices[Math.floor(prices.length * 0.75)] : Infinity;

  cards.forEach(function (card) {
    var price = parseFloat(card.getAttribute('data-max-price')) || 0;
    if (price > 0 && price >= premiumThreshold) {
      card.setAttribute('data-premium', 'true');
    }
  });

  // Las letras sin ninguna marca real no tienen sentido como filtro: se apagan solas.
  var lettersPresent = {};
  cards.forEach(function (card) {
    lettersPresent[card.getAttribute('data-letter')] = true;
  });

  Array.prototype.forEach.call(container.querySelectorAll('[data-letter]'), function (btn) {
    var letter = btn.getAttribute('data-letter');
    if (letter !== 'all' && !lettersPresent[letter]) {
      btn.disabled = true;
      btn.classList.add('is-disabled');
    }
  });

  var state = { category: 'all', letter: 'all', query: '' };
  var searchInput = document.getElementById('brand-filters-search-input');

  // Nombre de cada marca en minúscula, calculado una sola vez (no en cada tecla) para que
  // el buscador ande fluido incluso con muchas marcas en la grilla.
  var cardNames = cards.map(function (card) {
    var nameEl = card.querySelector('.quick-links__name');
    return nameEl ? nameEl.textContent.trim().toLowerCase() : '';
  });

  function setCardVisible(card, visible) {
    if (visible) {
      card.style.display = '';
      void card.offsetWidth; // reflow para que la transición de entrada sí se vea
      card.classList.remove('is-hidden-by-filter');
    } else {
      card.classList.add('is-hidden-by-filter');
      window.setTimeout(function () {
        if (card.classList.contains('is-hidden-by-filter')) {
          card.style.display = 'none';
        }
      }, 220);
    }
  }

  function applyFilters() {
    var visibleCount = 0;

    cards.forEach(function (card, index) {
      var matchesCategory = state.category === 'all' || (state.category === 'premium' && card.getAttribute('data-premium') === 'true');
      var matchesLetter = state.letter === 'all' || card.getAttribute('data-letter') === state.letter;
      var matchesQuery = state.query === '' || cardNames[index].indexOf(state.query) !== -1;
      var show = matchesCategory && matchesLetter && matchesQuery;

      if (show) {
        visibleCount++;
      }

      setCardVisible(card, show);
    });

    if (emptyMessage) {
      emptyMessage.hidden = visibleCount !== 0;
    }
  }

  if (searchInput) {
    var searchDebounce;
    searchInput.addEventListener('input', function () {
      clearTimeout(searchDebounce);
      var value = searchInput.value;
      searchDebounce = setTimeout(function () {
        state.query = value.trim().toLowerCase();

        // Escribir un nombre de marca ya asume "todas las marcas", no tiene sentido que
        // siga limitado a una sola letra A-Z a la vez: lo reseteamos para que la búsqueda
        // no parezca que "no encuentra nada" por un filtro de letra que quedó activo.
        if (state.query !== '' && state.letter !== 'all') {
          state.letter = 'all';
          Array.prototype.forEach.call(container.querySelectorAll('[data-letter]'), function (btn) {
            btn.classList.toggle('is-active', btn.getAttribute('data-letter') === 'all');
          });
        }

        applyFilters();
      }, 120);
    });
  }

  container.addEventListener('click', function (event) {
    var categoryBtn = event.target.closest('[data-filter]');
    if (categoryBtn) {
      state.category = categoryBtn.getAttribute('data-filter');
      Array.prototype.forEach.call(container.querySelectorAll('[data-filter]'), function (btn) {
        btn.classList.toggle('is-active', btn === categoryBtn);
      });
      applyFilters();
      return;
    }

    var letterBtn = event.target.closest('[data-letter]');
    if (letterBtn && !letterBtn.disabled) {
      state.letter = letterBtn.getAttribute('data-letter');
      Array.prototype.forEach.call(container.querySelectorAll('[data-letter]'), function (btn) {
        btn.classList.toggle('is-active', btn === letterBtn);
      });
      applyFilters();
    }
  });
})();

/**
 * Transición suave al cambiar entre vista grid/list en colección y búsqueda.
 * El cambio de clases en cada .product-item lo hace el tema (theme.js, vía
 * fastdom.mutate en el siguiente frame) — nosotros no lo tocamos. Lo que hacemos es
 * un fundido corto sobre el contenedor: se apaga un poco, ese cambio ya alcanzó a
 * ocurrir, y se enciende de nuevo, para que el salto de layout (grid <-> fila) no se
 * sienta brusco.
 */
(function () {
  var FADE_MS = 220;

  function getGrid(button) {
    var toolbar = button.closest('.card, .collection__toolbar-wrapper, form, .container');
    var scope = toolbar || document;
    return scope.querySelector('.product-list--collection') || document.querySelector('.product-list--collection');
  }

  document.addEventListener('click', function (event) {
    // El tema dispara un click programático sobre el botón de vista por defecto al
    // iniciar la página (para sincronizar el estado inicial) — event.isTrusted es
    // false en ese caso, así que lo ignoramos y solo animamos clics reales del usuario.
    if (!event.isTrusted) {
      return;
    }

    var button = event.target.closest('[data-action="change-layout"]');
    if (!button || button.classList.contains('is-selected')) {
      return;
    }

    var grid = getGrid(button);
    if (!grid) {
      return;
    }

    grid.classList.add('is-switching-view');

    window.setTimeout(function () {
      grid.classList.remove('is-switching-view');
    }, FADE_MS + 260);
  });
})();

/**
 * El ícono del carrito del header "reacciona" cuando se agrega un producto. El tema ya
 * dispara el evento "product:added" en el documento (documentado arriba, al inicio de este
 * archivo) cada vez que algo se agrega al carrito — solo escuchamos y togglear la clase que
 * dispara la animación en custom.css.
 */
(function () {
  var cartIcon = document.querySelector('.header__cart-icon');
  if (!cartIcon) {
    return;
  }

  document.documentElement.addEventListener('product:added', function () {
    cartIcon.classList.remove('is-bumping');
    void cartIcon.offsetWidth; // fuerza reflow para poder re-disparar la animación
    cartIcon.classList.add('is-bumping');
  });

  cartIcon.addEventListener('animationend', function () {
    cartIcon.classList.remove('is-bumping');
  });
})();

/**
 * Fix: el carrusel de "Recently Viewed" (producto y carrito) inyecta su HTML por fetch y
 * llama a Flickity ANTES de que las imágenes carguen, así que Flickity calcula el layout con
 * el contenedor todavía vacío y el viewport queda mal posicionado (los productos "desaparecen").
 * Flickity ya escucha el evento resize de window para recalcular su layout, así que cuando las
 * imágenes de la sección terminan de cargar, disparamos un resize sintético para forzar el
 * recálculo correcto, sin tocar el bundle de Flickity/theme.js.
 */
(function () {
  var resizeTimer;

  function triggerFlickityResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      window.dispatchEvent(new Event('resize'));
    }, 80);
  }

  var placeholders = document.querySelectorAll('.recently-viewed-products-placeholder');
  if (!placeholders.length) {
    return;
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      var images = mutation.target.querySelectorAll('img');
      if (!images.length) {
        triggerFlickityResize();
        return;
      }
      images.forEach(function (img) {
        if (img.complete) {
          return;
        }
        img.addEventListener('load', triggerFlickityResize, { once: true });
      });
      // Also schedule a resize right away in case every image was already cached/complete.
      triggerFlickityResize();
    });
  });

  placeholders.forEach(function (placeholder) {
    observer.observe(placeholder, { childList: true });
  });
})();

/**
 * Count-up en la stats bar: cuando cada número (99.9%, 506K, 30K, etc.) entra en pantalla,
 * anima desde 0 hasta su valor final. El texto final que queda es exactamente el mismo que
 * ya estaba en el HTML (no se modifica ningún valor, solo se anima la transición hacia él).
 * Se excluyen los logos de eBay/Amazon (stats-bar__value--logo, son SVG, no números).
 * A pedido explícito: esta animación corre siempre, incluso con prefers-reduced-motion
 * activado en el sistema, porque es un simple cambio de texto (sin movimiento, parpadeo
 * ni desplazamiento en pantalla) y no dispara mareo/vestibular como sí puede hacerlo un
 * parallax o una transición grande.
 */
(function () {
  function parseValue(text) {
    var match = text.match(/^([^\d]*)([\d,]*\.?\d+)([^\d]*)$/);
    if (!match || match[2] === '') {
      return null;
    }
    var numStr = match[2].replace(/,/g, '');
    var target = parseFloat(numStr);
    if (isNaN(target)) {
      return null;
    }
    return {
      prefix: match[1] || '',
      suffix: match[3] || '',
      target: target,
      decimals: (numStr.split('.')[1] || '').length,
      hasComma: match[2].indexOf(',') !== -1
    };
  }

  function formatNumber(value, decimals, hasComma) {
    var fixed = value.toFixed(decimals);
    if (!hasComma) {
      return fixed;
    }
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  function animateValue(el, data) {
    var duration = 1400;
    var startTime = null;
    var originalText = el.textContent;

    function step(timestamp) {
      if (!startTime) {
        startTime = timestamp;
      }
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = data.prefix + formatNumber(data.target * eased, data.decimals, data.hasComma) + data.suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = originalText;
      }
    }
    requestAnimationFrame(step);
  }

  var statValues = document.querySelectorAll('.stats-bar__value:not(.stats-bar__value--logo)');
  if (!statValues.length || !('IntersectionObserver' in window)) {
    return;
  }

  var statsObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) {
        return;
      }
      var data = parseValue(entry.target.textContent.trim());
      if (data) {
        animateValue(entry.target, data);
      }
      statsObserver.unobserve(entry.target);
    });
  }, { threshold: 0.4 });

  function startObserving() {
    statValues.forEach(function (el) {
      statsObserver.observe(el);
    });
  }

  // Si empezamos a observar mientras el loader normal y/o la bienvenida todavía tapan la
  // página, la stats bar puede estar "en pantalla" para el navegador (aunque el usuario no
  // la vea) y la animación arranca y termina detrás del overlay: cuando por fin se revela
  // el sitio, los números ya están quietos en su valor final. Por eso esperamos a que
  // 'sh:content-visible' confirme que el usuario ya está viendo la página real.
  if (window.__shContentVisible) {
    startObserving();
  } else {
    document.addEventListener('sh:content-visible', startObserving, { once: true });
  }
})();

/**
 * Barra sticky de "Add to cart" para móvil/tablet en la página de producto.
 * No toca el markup Liquid: se arma e inyecta 100% desde JS. Se muestra (solo <1000px, vía
 * CSS) cuando el botón de compra real sale de la pantalla, y su botón simplemente dispara un
 * click sobre el botón real — así hereda gratis toda la lógica existente (carrito AJAX,
 * variantes, "Agregando...", sold out) sin duplicar nada ni arriesgar que se desincronicen.
 */
(function () {
  var form = document.querySelector('.product-form');
  if (!form || form.closest('dialog')) {
    return; // No es la página de producto real, o es el modal de quick view.
  }

  var realButton = form.querySelector('.product-form__add-button[data-action="add-to-cart"]');
  var disabledButton = form.querySelector('.product-form__add-button.button--disabled');
  var triggerButton = realButton || disabledButton;
  if (!triggerButton) {
    return;
  }

  var priceList = form.querySelector('.price-list');
  var titleEl = document.querySelector('.product-meta__title');
  var galleryImg = document.querySelector('.product-gallery__image, .product-gallery img, .product-block-list__item--gallery img');
  // La imagen principal usa lazyload: su "src" real se arma recién cuando el plugin de
  // lazysizes reemplaza el placeholder "{width}" del atributo data-src por un número. Si
  // corremos antes de que eso pase, hay que hacer nosotros mismos ese reemplazo para no
  // terminar con una URL rota tipo ..._{width}x.png.
  var galleryImgSrc = null;
  if (galleryImg) {
    if (galleryImg.currentSrc && galleryImg.currentSrc.indexOf('{width}') === -1) {
      galleryImgSrc = galleryImg.currentSrc;
    } else if (galleryImg.getAttribute('data-src')) {
      galleryImgSrc = galleryImg.getAttribute('data-src').replace('{width}', '84');
    } else if (galleryImg.src && galleryImg.src.indexOf('{width}') === -1) {
      galleryImgSrc = galleryImg.src;
    }
  }

  var bar = document.createElement('div');
  bar.className = 'mobile-sticky-atc';
  bar.setAttribute('role', 'region');
  bar.setAttribute('aria-label', 'Compra rápida');

  var mediaHtml = '';
  if (galleryImgSrc) {
    // Sin loading="lazy": la barra vive oculta (display:none/transform) hasta que el
    // usuario scrollea, y algunos navegadores nunca "descubren" una imagen lazy dentro de
    // un contenedor que no tenía layout visible al insertarla. Es una miniatura de 42px,
    // el costo de cargarla enseguida es mínimo.
    mediaHtml = '<div class="mobile-sticky-atc__media"><img src="' + galleryImgSrc + '" alt="" decoding="async"></div>';
  }

  bar.innerHTML =
    mediaHtml +
    '<div class="mobile-sticky-atc__info">' +
      '<span class="mobile-sticky-atc__title"></span>' +
      '<div class="mobile-sticky-atc__price"></div>' +
    '</div>' +
    '<button type="button" class="mobile-sticky-atc__button button button--primary"></button>';

  document.body.appendChild(bar);

  var titleSlot = bar.querySelector('.mobile-sticky-atc__title');
  var priceSlot = bar.querySelector('.mobile-sticky-atc__price');
  var buttonSlot = bar.querySelector('.mobile-sticky-atc__button');

  if (titleSlot) {
    titleSlot.textContent = titleEl ? titleEl.textContent.trim() : document.title;
  }

  function syncPrice() {
    if (priceSlot && priceList) {
      priceSlot.innerHTML = priceList.innerHTML;
    }
  }

  function syncButton() {
    buttonSlot.textContent = triggerButton.textContent.trim();
    buttonSlot.disabled = !!triggerButton.disabled;
  }

  syncPrice();
  syncButton();

  buttonSlot.addEventListener('click', function () {
    if (!buttonSlot.disabled && realButton) {
      realButton.click();
    }
  });

  // Mantiene la barra sincronizada si el usuario cambia de variante (precio, stock, texto
  // del botón) o si el tema cambia el botón a estado "Agregando..." durante el submit.
  if (priceList && 'MutationObserver' in window) {
    new MutationObserver(syncPrice).observe(priceList, { childList: true, characterData: true, subtree: true });
  }
  if ('MutationObserver' in window) {
    new MutationObserver(syncButton).observe(triggerButton, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
  }

  // Muestra la barra solo cuando el botón real de compra salió de la pantalla.
  // También avisa (clase en <body> + variable CSS con la altura real) para que widgets de
  // apps externas que flotan fijos en la esquina inferior (ej. el globo de "Rewards" de
  // Smile.io, o badges de confianza tipo TrustedSite) se corran para arriba en vez de
  // quedar tapados/atravesados por esta barra. Ver el bloque correspondiente en custom.css.
  function updateStickyAtcHeightVar() {
    document.documentElement.style.setProperty('--sticky-atc-height', bar.offsetHeight + 'px');
  }

  if ('IntersectionObserver' in window) {
    var visibilityObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var visible = !entry.isIntersecting;
        bar.classList.toggle('is-visible', visible);
        document.body.classList.toggle('has-sticky-atc-visible', visible);
        if (visible) {
          updateStickyAtcHeightVar();
        }
      });
    }, { threshold: 0 });
    visibilityObserver.observe(triggerButton);
  }

  window.addEventListener('resize', updateStickyAtcHeightVar);
})();

/**
 * Wishlist / favoritos, 100% cliente (localStorage), sin backend ni cuenta de cliente.
 * Igual que las otras mejoras de esta tanda: se arma e inyecta entera desde JS, no toca
 * ningún archivo .liquid, así que funciona en TODAS las grillas de producto del sitio
 * (colección, home, buscador, recomendados, recién vistos, upsell del carrito) sin
 * duplicar código Liquid ni arriesgar romper esas plantillas.
 * - Corazón sobre cada product-item (agrega/quita).
 * - Ícono de corazón en el header, con contador, que abre un panel con lo guardado.
 * - Botón "Guardar" en la página de producto, junto al formulario de compra real.
 */
(function () {
  var STORAGE_KEY = 'sh-wishlist';
  var HEART_PATH = 'M15.0349331 1.40485867C14.1287273.49933787 12.9252477 0 11.6443673 0S9.16000731.49933787 8.25448651 1.40417371c-.01164437.01164436-.02328874.02328873-.03493311.03561806-.01164436-.01232933-.02260377-.02328873-.03424813-.0349331C7.2790995.49933787 6.07561989 0 4.79473949 0 3.51385908 0 2.31037947.49933787 1.40417371 1.40485867.49796794 2.31037947 0 3.51385908 0 4.79473949 0 6.07561989.4986529 7.2790995 1.40417371 8.1846203L8.2195534 15l6.8153797-6.8153797c.9055208-.9055208 1.4041737-2.10900041 1.4041737-3.38988081 0-1.28019545-.4986529-2.48436002-1.4041737-3.38988082z';

  function heartSvg() {
    return '<svg viewBox="0 0 17 15" width="17" height="15" aria-hidden="true"><path d="' + HEART_PATH + '"></path></svg>';
  }

  function getList() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(raw) ? raw : [];
    } catch (e) {
      return [];
    }
  }

  function setList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      // Almacenamiento no disponible (modo privado, cuota, etc.): la wishlist simplemente
      // no persiste entre visitas, pero no rompe nada del resto de la página.
    }
    document.dispatchEvent(new CustomEvent('sh-wishlist:change', { detail: { list: list } }));
  }

  function isSaved(handle) {
    return getList().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = getList();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    setList(list);
    return idx === -1;
  }

  function extractHandle(url) {
    if (!url) {
      return null;
    }
    var match = url.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  /* ---------- Corazón sobre cada tarjeta de producto ---------- */

  function buildCardHeart(handle) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wishlist-heart';
    if (isSaved(handle)) {
      btn.classList.add('is-active');
    }
    btn.setAttribute('aria-pressed', isSaved(handle) ? 'true' : 'false');
    btn.setAttribute('aria-label', 'Add to wishlist');
    btn.innerHTML = heartSvg();
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var nowSaved = toggle(handle);
      btn.classList.toggle('is-active', nowSaved);
      btn.setAttribute('aria-pressed', nowSaved ? 'true' : 'false');
      btn.setAttribute('aria-label', nowSaved ? 'Remove from wishlist' : 'Add to wishlist');
    });
    return btn;
  }

  function injectCardHearts(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = scope.querySelectorAll('.product-item:not([data-wishlist-ready])');
    cards.forEach(function (card) {
      var link = card.querySelector('.product-item__image-wrapper') || card.querySelector('.product-item__title');
      var handle = link ? extractHandle(link.getAttribute('href')) : null;
      if (!handle) {
        return;
      }
      card.setAttribute('data-wishlist-ready', 'true');
      card.classList.add('has-wishlist-heart');
      card.appendChild(buildCardHeart(handle));
    });
  }

  /* ---------- Botón "Guardar" en la página de producto ---------- */

  function injectProductPageButton() {
    var form = document.querySelector('.product-form');
    if (!form || form.closest('dialog')) {
      return;
    }
    var paymentContainer = form.querySelector('.product-form__payment-container');
    if (!paymentContainer || paymentContainer.querySelector('.wishlist-save-button')) {
      return;
    }
    var canonical = document.querySelector('link[rel="canonical"]');
    var handle = extractHandle(canonical ? canonical.getAttribute('href') : window.location.pathname);
    if (!handle) {
      return;
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wishlist-save-button button button--secondary';
    if (isSaved(handle)) {
      btn.classList.add('is-active');
    }

    function render() {
      var saved = isSaved(handle);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      btn.innerHTML = heartSvg() + '<span>' + (saved ? 'Saved' : 'Save for later') + '</span>';
    }
    render();

    btn.addEventListener('click', function () {
      toggle(handle);
      btn.classList.toggle('is-active', isSaved(handle));
      render();
    });

    // Se inserta DESPUÉS del contenedor de pago, no adentro: ese contenedor es un flex row
    // que ya reparte el ancho entre "Add to cart" / "Buy it now" existentes, y agregar un
    // tercer hijo ahí cambiaría el tamaño de esos dos botones. Así queda como una fila
    // nueva propia, sin tocar el layout de los botones que ya estaban.
    var wrapper = document.createElement('div');
    wrapper.className = 'wishlist-save-button-wrapper';
    wrapper.appendChild(btn);
    paymentContainer.insertAdjacentElement('afterend', wrapper);
  }

  /* ---------- Ícono del header + contador ---------- */

  var wishlistCountEls = [];

  function updateHeaderCount() {
    var count = getList().length;
    wishlistCountEls.forEach(function (el) {
      el.textContent = count;
    });
    document.body.classList.toggle('has-wishlist-items', count > 0);
  }

  function injectHeaderIcon() {
    var cartItem = document.querySelector('.header__action-item--cart');
    if (!cartItem || document.querySelector('.header__action-item--wishlist')) {
      return;
    }

    var wrapper = document.createElement('div');
    wrapper.className = 'header__action-item header__action-item--wishlist';
    wrapper.innerHTML =
      '<button type="button" class="header__action-item-link" data-action="open-wishlist-panel">' +
        '<div class="header__action-item-content">' +
          '<div class="header__cart-icon icon-state">' +
            '<span class="icon-state__primary">' +
              heartSvg() +
              '<span class="header__cart-count header__wishlist-count">0</span>' +
            '</span>' +
          '</div>' +
          '<span class="hidden-pocket hidden-lap">Wishlist</span>' +
        '</button>' +
      '</div>';

    cartItem.parentNode.insertBefore(wrapper, cartItem);
    var countEl = wrapper.querySelector('.header__wishlist-count');
    wishlistCountEls.push(countEl);
    wrapper.querySelector('button').addEventListener('click', openPanel);
  }

  /* ---------- Panel con lo guardado ---------- */

  var panelDialog = null;
  var panelListEl = null;

  function buildPanel() {
    if (panelDialog) {
      return;
    }
    panelDialog = document.createElement('dialog');
    panelDialog.className = 'wishlist-panel';
    panelDialog.innerHTML =
      '<div class="wishlist-panel__header">' +
        '<p class="wishlist-panel__title heading h3">Wishlist</p>' +
        '<button type="button" class="wishlist-panel__close" aria-label="Close">' + closeSvg() + '</button>' +
      '</div>' +
      '<div class="wishlist-panel__body"></div>';
    document.body.appendChild(panelDialog);
    panelListEl = panelDialog.querySelector('.wishlist-panel__body');

    panelDialog.querySelector('.wishlist-panel__close').addEventListener('click', function () {
      panelDialog.close();
    });
    panelDialog.addEventListener('click', function (event) {
      if (event.target === panelDialog) {
        panelDialog.close();
      }
    });
  }

  function closeSvg() {
    return '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"></path></svg>';
  }

  function renderPanel() {
    var list = getList();
    if (!list.length) {
      panelListEl.innerHTML = '<p class="wishlist-panel__empty">No items saved yet. Tap the heart on any product to add it here.</p>';
      return;
    }

    panelListEl.innerHTML = '<p class="wishlist-panel__loading">Loading...</p>';

    Promise.all(
      list.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .catch(function () {
            return null;
          })
          .then(function (product) {
            return { handle: handle, product: product };
          });
      })
    ).then(function (results) {
      var html = results
        .map(function (entry) {
          if (!entry.product) {
            return '';
          }
          var p = entry.product;
          var image = p.featured_image ? p.featured_image.replace('{width}', '120') : (p.images && p.images[0] ? p.images[0].replace('{width}', '120') : '');
          var price = (p.price / 100).toFixed(2);
          return (
            '<div class="wishlist-panel__item">' +
              (image ? '<img src="' + image + '" alt="" class="wishlist-panel__item-image" loading="lazy">' : '') +
              '<div class="wishlist-panel__item-info">' +
                '<a href="' + p.url + '" class="wishlist-panel__item-title">' + p.title + '</a>' +
                '<span class="wishlist-panel__item-price">$' + price + '</span>' +
              '</div>' +
              '<button type="button" class="wishlist-panel__item-remove" data-handle="' + entry.handle + '" aria-label="Remove">' + closeSvg() + '</button>' +
            '</div>'
          );
        })
        .join('');

      panelListEl.innerHTML = html || '<p class="wishlist-panel__empty">No items saved yet.</p>';

      panelListEl.querySelectorAll('.wishlist-panel__item-remove').forEach(function (removeBtn) {
        removeBtn.addEventListener('click', function () {
          toggle(removeBtn.dataset.handle);
          renderPanel();
        });
      });
    });
  }

  function openPanel() {
    buildPanel();
    renderPanel();
    if (typeof panelDialog.showModal === 'function') {
      panelDialog.showModal();
    } else {
      panelDialog.setAttribute('open', '');
    }
  }

  /* ---------- Arranque ---------- */

  injectCardHearts();
  injectProductPageButton();
  injectHeaderIcon();
  updateHeaderCount();

  document.addEventListener('sh-wishlist:change', function () {
    updateHeaderCount();
    // Refleja el nuevo estado en corazones ya inyectados (por si el mismo producto
    // aparece repetido en varias secciones de la página, ej. destacados + recién vistos).
    document.querySelectorAll('.wishlist-heart').forEach(function (heart) {
      var card = heart.closest('.product-item');
      var link = card ? (card.querySelector('.product-item__image-wrapper') || card.querySelector('.product-item__title')) : null;
      var handle = link ? extractHandle(link.getAttribute('href')) : null;
      if (!handle) {
        return;
      }
      var saved = isSaved(handle);
      heart.classList.toggle('is-active', saved);
      heart.setAttribute('aria-pressed', saved ? 'true' : 'false');
    });
    if (panelDialog && panelDialog.open) {
      renderPanel();
    }
  });

  // Cubre tarjetas que se agregan después (resultados de búsqueda, filtros AJAX de
  // colección, "recién vistos" que se inyectan por fetch, etc.).
  if ('MutationObserver' in window) {
    var debounceTimer;
    var bodyObserver = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        injectCardHearts();
      }, 150);
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }
})();

/**
 * Agrupa la etiqueta y el valor de cada fila de specs (Brand, Model, UPC...) en la ficha
 * de producto (Featured product y página de producto). El HTML pegado del proveedor pone
 * la etiqueta en <b>/<strong> y el valor suelto después — a veces en un solo <span>, a
 * veces partido en varios (ej. "7." + "5\" (19." + "05cm)" en vez de un solo bloque).
 * 1) Solo se marca como fila de specs (.spec-row) el párrafo que arranca con una etiqueta
 *    en negrita: un párrafo de prosa normal (sin ese patrón) queda intacto, no se le
 *    fuerza el layout de fila.
 * 2) Todo lo que sigue a la etiqueta se agrupa en un único <span class="spec-value">, así
 *    el CSS lo alinea a la derecha como un solo bloque en vez de que cada <span> suelto
 *    del proveedor compita por su propio espacio como ítem flex independiente.
 * Corre en la carga inicial y de nuevo cada vez que se inyecta contenido nuevo (quick
 * view), vía el mismo patrón de MutationObserver que ya usa el resto de este archivo.
 */
(function () {
  function enhanceRow(p) {
    if (p.classList.contains('spec-row') || p.dataset.specChecked) {
      return;
    }
    p.dataset.specChecked = 'true';

    var label = p.firstElementChild;
    if (!label || (label.tagName !== 'B' && label.tagName !== 'STRONG')) {
      return;
    }

    var toMove = [];
    var node = label.nextSibling;
    while (node) {
      toMove.push(node);
      node = node.nextSibling;
    }
    if (!toMove.length) {
      return;
    }

    var valueWrapper = document.createElement('span');
    valueWrapper.className = 'spec-value';
    toMove.forEach(function (n) {
      valueWrapper.appendChild(n);
    });
    p.appendChild(valueWrapper);
    p.classList.add('spec-row');
  }

  function enhance(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var descriptions = scope.querySelectorAll('.product-description, .product-meta__description');
    descriptions.forEach(function (desc) {
      var paragraphs = desc.querySelectorAll('p');
      paragraphs.forEach(function (p, index) {
        if (index === 0) {
          return; // El primer <p> es la intro, nunca una fila de specs.
        }
        enhanceRow(p);
      });
    });
  }

  enhance();

  if ('MutationObserver' in window) {
    var specDebounce;
    var specObserver = new MutationObserver(function () {
      clearTimeout(specDebounce);
      specDebounce = setTimeout(function () {
        enhance();
      }, 150);
    });
    specObserver.observe(document.body, { childList: true, subtree: true });
  }
})();